module.exports = __webpack_public_path__ + "img/logo_l1.765c7ebf.png";